import { HealthTeam } from "@/@types/esus/HealthTeam";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorC7ByHealthTeamParams = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorC7ByHealthTeamData {
	healthTeam?: HealthTeam;
	weightedPercentage: number = 0;
	generalPercentage: number = 0;
	totalCervicalCancerCitizens: number = 0;
	totalCervicalCancerCitizensFinished: number = 0;
	totalVaccinationCitizens: number = 0;
	totalVaccinationCitizensFinished: number = 0;
	totalAttendanceCitizens: number = 0;
	totalAttendanceCitizensFinished: number = 0;
	totalBreastCancerCitizens: number = 0;
	totalBreastCancerCitizensFinished: number = 0;
}

export async function getResumeIndicatorC7ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorC7ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorC7ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c7/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorC7ByHealthTeamData>();
}
